import React from 'react';
import EnhancedBarChart from '../EnhancedBarChart/EnhancedBarChart';
import { EnhancedBarChartProps } from '../EnhancedBarChart/EnhancedBarChart.types';

/**
 * Horizontal bar chart component that accepts the same input format as EnhancedBarChart.
 * Renders bars horizontally instead of vertically.
 *
 * - Filters: Same as EnhancedBarChart (X-axis, Primary/Secondary Axis, Z-axis from vizData, or custom filters)
 * - Slider: Vertical slider on the left (categories axis) for focusing on category ranges when showSlider is true
 * - Scrollbar: When showScrollbar is true (or vizData.xAxisType is `Category`), a vertical scrollbar
 *   renders on the left, next to the category axis labels — mirroring the bottom scrollbar on the
 *   vertical EnhancedBarChart. Users can also scroll via mouse wheel or vertical touch swipe.
 * - Category names on the left axis: full text, no ellipsis (see EnhancedBarChart when `horizontal` — dynamic axis width + padding)
 */
const EnhancedHorizontalBarChart: React.FC<EnhancedBarChartProps> = (props) => {
    return <EnhancedBarChart {...props} horizontal />;
};

export default EnhancedHorizontalBarChart;
